<template>
  <div>
    <Header title="Primes" v-model:selectedMonth="selectedMonth" />

    <Booster
      v-if="retributionsBoostEnabled(store) && retributionsAnalytics?.retributionConfigurationsExist"
      :retributionsAnalytics="retributionsAnalytics"
    />

    <RetributionsAnalytics
      :retributionsAnalytics="retributionsAnalytics"
      :showManagementRetributionView="true"
      @viewDetails="viewDetails"
    />
    <RetributionDetailsModal
      v-if="sellerIdDetails"
      :seller-id="sellerIdDetails"
      :start-at="startAt"
      :end-at="endAt"
      :open="openDetailsModal"
      @close="openDetailsModal = false"
    />
  </div>
</template>

<script>
import RetributionsAnalytics from "@/components/retribution/RetributionsAnalytics.vue";
import { startOfMonth, endOfMonth, format } from "date-fns";
import { mapActions, mapState, mapGetters } from "vuex";
import Header from "@/components/admin/retributions/Header.vue";
import RetributionDetailsModal from "@/components/retribution/RetributionDetailsModal.vue";
import Booster from "@/components/retribution/Booster.vue";

export default {
  components: {
    RetributionDetailsModal,
    Header,
    RetributionsAnalytics,
    Booster,
  },

  data() {
    return {
      retributionsAnalytics: null,
      selectedMonth: new Date(),
      openDetailsModal: false,
      sellerIdDetails: null,
    };
  },

  mounted() {
    this.handleMonthChange();
  },

  computed: {
    ...mapState({
      retributionConfigurationsSelectedStoreId: (state) => state.retributionConfigurations.selectedStoreId,
    }),
    ...mapState("store", { stores: "index" }),
    ...mapGetters("store", ["retributionsBoostEnabled"]),

    store() {
      return this.stores.find((store) => store.id === this.retributionConfigurationsSelectedStoreId);
    },

    startAt() {
      if (!this.selectedMonth) return null;

      const d = startOfMonth(this.selectedMonth);
      // On force bien 00:00:00 locale
      d.setHours(0, 0, 0, 0);

      return format(d, "yyyy-MM-dd'T'HH:mm:ss"); // ex: "2025-11-01T00:00:00"
    },

    endAt() {
      if (!this.selectedMonth) return null;

      const d = endOfMonth(this.selectedMonth);
      // On force bien 23:59:59 locale
      d.setHours(23, 59, 59, 999);

      return format(d, "yyyy-MM-dd'T'HH:mm:ss"); // ex: "2025-11-30T23:59:59"
    },
  },

  watch: {
    selectedMonth() {
      this.handleMonthChange();
    },
    retributionConfigurationsSelectedStoreId() {
      this.handleMonthChange();
    },
  },

  methods: {
    ...mapActions("retributions", ["fetchRetributionsAnalytics"]),

    async handleMonthChange() {
      if (!this.selectedMonth) return;

      this.retributionsAnalytics = await this.fetchRetributionsAnalytics({
        storeId: this.retributionConfigurationsSelectedStoreId,
        startAt: this.startAt,
        endAt: this.endAt,
      });
    },

    viewDetails(sellerId) {
      this.sellerIdDetails = sellerId;
      this.openDetailsModal = true;
    },
  },
};
</script>
